import QRCode from 'qrcode-svg';
import Settings from '../wrappers/Settings';
import Store from '../wrappers/Store';
import { I18n } from '../wrappers/I18n';
export function generateTableQrCardsHtml(tables) {
    const tenant = Store.get('tenant');
    const baseUrl = Settings.env?.QR_CODE_ORDERING_URL;
    const venueHash = tenant?.venue?.hash;
    const venueName = tenant?.venue?.name || '';
    // The guest menu app selects its backend from the country segment in the URL,
    // so the QR must carry the venue's locale (me|sr|ba). Skip otherwise.
    const locale = tenant?.venue?.locale;
    const hasCountry = ['me', 'sr', 'ba'].includes(locale);
    // The "ask your waiter for the PIN" hint only applies when PIN protection is
    // on; in open mode there's no PIN, so omit it (matches TableCardPrintable).
    const showPinHint = tenant?.venue?.settings?.qr_ordering?.security_mode !== 'open';
    if (!baseUrl || !venueHash || !hasCountry)
        return '';
    const cards = tables.map(table => {
        const qrUrl = `${baseUrl}/${locale}/${venueHash}/${table.id}`;
        const qrSvg = new QRCode({
            content: qrUrl,
            padding: 0,
            ecl: 'M',
            join: true,
            container: 'svg-viewbox'
        }).svg();
        return `
            <div class="card">
                <div class="venue-name">${escapeHtml(venueName)}</div>
                <div class="table-name">${escapeHtml(I18n.t('general.table'))}: ${escapeHtml(table.name)}</div>
                <div class="qr-code">${qrSvg}</div>
                <div class="cta">${escapeHtml(I18n.t('qr_ordering.scan_to_order'))}</div>
                ${showPinHint ? `<div class="pin-hint">${escapeHtml(I18n.t('qr_ordering.pin_hint'))}</div>` : ''}
            </div>`;
    }).join('\n');
    return `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<title>${escapeHtml(I18n.t('qr_ordering.print_table_cards'))}</title>
<style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; }

    .cards {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 24px;
        padding: 24px;
    }

    .card {
        border: 1px solid #ddd;
        border-radius: 12px;
        padding: 28px 24px;
        text-align: center;
        page-break-inside: avoid;
        break-inside: avoid;
    }

    .venue-name {
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 1.5px;
        color: #999;
        margin-bottom: 8px;
    }

    .table-name {
        font-size: 22px;
        font-weight: 700;
        margin-bottom: 20px;
    }

    .qr-code {
        display: flex;
        justify-content: center;
        margin-bottom: 20px;
    }

    .qr-code svg {
        width: 160px;
        height: 160px;
    }

    .cta {
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 6px;
    }

    .pin-hint {
        font-size: 12px;
        color: #777;
    }

    @media print {
        body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        .cards { padding: 12px; gap: 16px; }
        .card { border: 1px solid #ccc; }
    }
</style>
</head>
<body>
<div class="cards">
${cards}
</div>
<script>window.onload = function() { window.print(); }<\/script>
</body>
</html>`;
}
function escapeHtml(text) {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}
//# sourceMappingURL=TableQrCardsHtml.js.map